/* Auto gift-with-purchase engine — adds/removes configured gift products as the
   qualifying cart subtotal crosses each tier's threshold. Gift lines are tagged
   with a _gift property (hidden at checkout) so the theme can suppress qty/remove. */
(function () {
  var reconciling = false, timer = null;

  function tiers() {
    var el = document.getElementById('cart-gift-config');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  function isGift(item) {
    return item.properties && (item.properties._gift || item.properties['_gift']);
  }

  function refreshDrawer() {
    return fetch('/?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var cur = document.querySelector('#cart-drawer, cart-drawer');
        if (!cur) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#cart-drawer, cart-drawer');
        if (fresh) cur.innerHTML = fresh.innerHTML;
      }).catch(function () {});
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  async function reconcile() {
    var cfg = tiers();
    if (!cfg.length || reconciling) return;
    reconciling = true;
    var changed = false;
    try {
      var cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
      // Qualifying subtotal excludes any gift lines (a gift can't unlock itself).
      var sub = 0;
      cart.items.forEach(function (it) { if (!isGift(it)) sub += it.final_line_price; });

      // Strip any manually-added duplicate of a gift product — only the auto _gift line is allowed
      var giftVariants = cfg.map(function (g) { return g.variant; });
      for (var k = 0; k < cart.items.length; k++) {
        var dup = cart.items[k];
        if (giftVariants.indexOf(dup.variant_id) !== -1 && !isGift(dup)) {
          await post('/cart/change.js', { id: dup.key, quantity: 0 });
          changed = true;
        }
      }

      for (var i = 0; i < cfg.length; i++) {
        var g = cfg[i];
        if (!g.variant) continue;
        var line = cart.items.find(function (it) { return it.variant_id === g.variant && isGift(it); });
        var qualifies = sub >= g.threshold;
        if (qualifies && !line) {
          await post('/cart/add.js', { id: g.variant, quantity: 1, properties: { _gift: 'true' } });
          changed = true;
        } else if (!qualifies && line) {
          await post('/cart/change.js', { id: line.key, quantity: 0 });
          changed = true;
        } else if (qualifies && line && line.quantity !== 1) {
          await post('/cart/change.js', { id: line.key, quantity: 1 }); // force qty 1
          changed = true;
        }
      }
    } catch (e) { /* fail quiet */ }
    reconciling = false;
    if (changed) await refreshDrawer();
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(reconcile, 350); }

  // Catch every cart mutation from any source (theme, LP, recommendations, qty changes)
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = nativeFetch.apply(this, arguments);
    try {
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url) && !reconciling) {
        p.then(function () { schedule(); }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile);
  else reconcile();
})();
